import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  TextField,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  Stack,
} from '@mui/material';

export default function AIImageAnalysisOptions({ data, updateOptions, onDataChange }) {
  const { t } = useTranslation(['procedures']);

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        {t('procedures:labels.ai_model')}
      </Typography>
      <Stack spacing={2}>
        <TextField
          select
          fullWidth
          label={t('procedures:labels.select_ai_model')}
          value={data.ai_model || ''}
          onChange={(e) => onDataChange({ ai_model: e.target.value })}
        >
          <MenuItem value="KONSTANSKONTROL">KONSTANSKONTROL</MenuItem>
        </TextField>
      </Stack>

      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        {t('procedures:step_options.ai_image_analysis_options')}
      </Typography>
      <Stack spacing={2}>
        <TextField
          fullWidth
          type="number"
          inputProps={{ step: '0.01', min: '0', max: '1' }}
          label="Confidence Threshold"
          value={data.options?.confidence_threshold || 0.8}
          onChange={(e) => updateOptions({ confidence_threshold: parseFloat(e.target.value) || 0.8 })}
        />
        <FormControlLabel
          control={
            <Switch
              checked={data.options?.auto_proceed || false}
              onChange={(e) => updateOptions({ auto_proceed: e.target.checked })}
            />
          }
          label="Auto Proceed"
        />
        <FormControlLabel
          control={
            <Switch
              checked={data.options?.show_raw_output || false}
              onChange={(e) => updateOptions({ show_raw_output: e.target.checked })}
            />
          }
          label="Show Raw Output"
        />
      </Stack>
    </>
  );
}
